import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[eoSplitCol]',
})
export class EoSplitCol {
  @Input() styleClass?: string;
  @Input() colSize?: string;
  @Input() scrollHeight?: string;

  constructor(public templateRef: TemplateRef<any>) {}
}
